<nav class="page-nav">
  <mat-toolbar color="primary" class="desktop-toolbar">
    <button [matMenuTriggerFor]="bookingMenu" #bookingMenuTrigger="matMenuTrigger"
      class="{{bookingMenuTrigger.menuOpen ? 'sub-menu-open' : rlBooking.isActive || rlAll.isActive ? 'active-link' : ''}}">
      Bokningar
    </button>
    <mat-menu #bookingMenu="matMenu" class="sub-menu">
      <button [routerLink]="['/hem']" routerLinkActive="active-link"
      #rlBooking="routerLinkActive">Hämtlista/Bokningar</button>
      <button [routerLink]="['/alla-bokningar']" routerLinkActive="active-link" #rlAll="routerLinkActive">
        Alla bokningar
      </button>
    </mat-menu>

    <button [matMenuTriggerFor]="orderMenu" #orderMenuTrigger="matMenuTrigger"
      class="{{orderMenuTrigger.menuOpen ? 'sub-menu-open' : rlOrder.isActive ? 'active-link' : ''}}">
      Ordrar
    </button>
    <mat-menu #orderMenu="matMenu" class="sub-menu">
      <button [routerLink]="['/ordrar']" routerLinkActive="active-link" #rlOrder="routerLinkActive">Alla ordrar</button>
      <!-- <button routerLinkActive="active-link">Fakturor</button> -->
    </mat-menu>

    <button [routerLink]="['/parkerade-bilar']" routerLinkActive="active-link">Parkerade bilar</button>
    <!-- <button>Tvätt</button> -->
    <button [routerLink]="['/prislistor']" routerLinkActive="active-link">Prislistor</button>
    <button [routerLink]="['/abonnemang']" routerLinkActive="active-link">Abonnemang</button>
    @if (isAdmin) {
      <button [routerLink]="['/schema']" routerLinkActive="active-link">Schema</button>
    }
    <button [routerLink]="['/avidentifiering']">Avidentifiering</button>
    <span class="toolbar-spacer"></span>
    @if (!isProd && (description == 'utvecklingsmiljö' || description == 'local')) {
      <button [routerLink]="['/relyit']" routerLinkActive="active-link"
      >Rely IT test</button>
    }
  </mat-toolbar>

  <div class="mobile-navigation">
    <div class="side-actions">
      @if (!activeOrder) {
        <button mat-icon-button [routerLink]="['/ny-bokning']" aria-label="Ny bokning">
          <mat-icon>add</mat-icon>
        </button>
      }
      @if (activeOrder) {
        <button mat-icon-button disabled aria-label="Ny bokning">
          <mat-icon>add</mat-icon>
        </button>
      }
      <button mat-icon-button (click)="openSearchDrawer.emit()" aria-label="Sök bland alla bokningar">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-icon-button (click)="openRegisterDrawer.emit()" aria-label="Kassa">
        <mat-icon>attach_money</mat-icon>
      </button>
    </div>
    <button class="mobile-menu-button" mat-icon-button [matMenuTriggerFor]="mobileMenu" #mobileMenuTrigger="matMenuTrigger"
      [attr.aria-label]="mobileMenuTrigger.menuOpen ? 'Stäng huvudmeny' : 'Öppna huvudmeny'"
      [class.menu-open]="mobileMenuTrigger.menuOpen">
      <mat-icon>{{ mobileMenuTrigger.menuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
  </div>

  <mat-menu #mobileMenu="matMenu" class="mobile-menu">
    <button mat-menu-item [matMenuTriggerFor]="mobileBookingMenu"
      [class.active-link]="rlBooking.isActive || rlAll.isActive">
      <!-- <mat-icon>book_online</mat-icon> -->
      <span>Bokningar</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="mobileOrderMenu" [class.active-link]="rlOrder.isActive">
      <!-- <mat-icon>shopping_cart</mat-icon> -->
      <span>Ordrar</span>
    </button>
    <button mat-menu-item [routerLink]="['/parkerade-bilar']" routerLinkActive="active-link">
      <!-- <mat-icon>directions_car</mat-icon> -->
      <span>Parkerade bilar</span>
    </button>
    <button mat-menu-item [routerLink]="['/prislistor']" routerLinkActive="active-link">
      <!-- <mat-icon>format_list_bulleted</mat-icon> -->
      <span>Prislistor</span>
    </button>
    <button mat-menu-item [routerLink]="['/abonnemang']" routerLinkActive="active-link">
      <!-- <mat-icon>card_membership</mat-icon> -->
      <span>Abonnemang</span>
    </button>
    @if (isAdmin) {
      <button mat-menu-item [routerLink]="['/schema']" routerLinkActive="active-link">
        <!-- <mat-icon>calendar_month</mat-icon> -->
        <span>Schema</span>
      </button>
    }
    <button mat-menu-item [routerLink]="['/avidentifiering']" routerLinkActive="active-link">
      <!-- <mat-icon>visibility_off</mat-icon> -->
      <span>Avidentifiering</span>
    </button>
    @if (!isProd && (description == 'utvecklingsmiljö' || description == 'local')) {
      <button mat-menu-item [routerLink]="['/relyit']" routerLinkActive="active-link"
        >
        <!-- <mat-icon>science</mat-icon> -->
        <span>Rely IT test</span>
      </button>
    }

    @if (isAdmin) {
      <div class="mobile-admin-section" role="group" aria-label="Administration">
        <span class="mobile-admin-heading">Administration</span>
        <button mat-menu-item [routerLink]="['/antal-p-platser']" routerLinkActive="active-link"
          (click)="partnerIsActiveNow = false">
          <span>Antal P-platser</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="mobileReportMenu"
          [class.active-link]="rlMobilePayment.isActive || rlMobileOccupancy.isActive || rlMobilePrepayments.isActive || rlMobileDailyArticles.isActive || rlMobileDailyPayment.isActive || rlMobileDayEnd.isActive"
          aria-label="Öppna administrationsmenyn Rapporter" (click)="partnerIsActiveNow = false">
          <span>Rapporter</span>
        </button>
        <button mat-menu-item [routerLink]="['/anvandare']" routerLinkActive="active-link"
          (click)="partnerIsActiveNow = false">
          <span>Användare</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="mobileSettingsMenu" [class.active-link]="rlMobileSettings.isActive"
          aria-label="Öppna administrationsmenyn Inställningar" (click)="partnerIsActiveNow = false">
          <span>Inställningar</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="mobilePartnersMenu" [class.active-link]="partnerIsActiveNow"
          aria-label="Öppna administrationsmenyn Partnerportalen">
          <span>Partnerportalen</span>
        </button>
      </div>
    }
  </mat-menu>

  <mat-menu #mobileBookingMenu="matMenu" class="mobile-menu">
    <button mat-menu-item [routerLink]="['/hem']" routerLinkActive="active-link">Hämtlista/Bokningar</button>
    <button mat-menu-item [routerLink]="['/alla-bokningar']" routerLinkActive="active-link">Alla bokningar</button>
  </mat-menu>

  <mat-menu #mobileOrderMenu="matMenu" class="mobile-menu">
    <button mat-menu-item [routerLink]="['/ordrar']" routerLinkActive="active-link">Alla ordrar</button>
  </mat-menu>

  <mat-menu #mobileReportMenu="matMenu" class="mobile-menu mobile-admin-menu">
    <button mat-menu-item [routerLink]="['/betalningsrapport']" routerLinkActive="active-link"
    #rlMobilePayment="routerLinkActive">Betalningsrapport</button>
    <button mat-menu-item [routerLink]="['/belaggningsrapport']" routerLinkActive="active-link"
    #rlMobileOccupancy="routerLinkActive">Beläggningsrapport</button>
    <button mat-menu-item [routerLink]="['/forskottsbetalningar']" routerLinkActive="active-link"
    #rlMobilePrepayments="routerLinkActive">Förskottsbetalningar</button>
    <button mat-menu-item [routerLink]="['/dagsrapport-artiklar']" routerLinkActive="active-link"
    #rlMobileDailyArticles="routerLinkActive">Dagsrapport - artiklar</button>
    <button mat-menu-item [routerLink]="['/dagsrapport-betalmetod']" routerLinkActive="active-link"
    #rlMobileDailyPayment="routerLinkActive">Dagsrapport - betalmetod</button>
    <button mat-menu-item [routerLink]="['/dagsavslut']" routerLinkActive="active-link"
    #rlMobileDayEnd="routerLinkActive">Dagsavslut</button>
  </mat-menu>

  <mat-menu #mobileSettingsMenu="matMenu" class="mobile-menu mobile-admin-menu">
    <button mat-menu-item [routerLink]="['/sms-installningar']" routerLinkActive="active-link"
    #rlMobileSettings="routerLinkActive">SMS</button>
  </mat-menu>

  <mat-menu #mobilePartnersMenu="matMenu" class="mobile-menu mobile-admin-menu">
    @for (partner of partners; track partner) {
      <button mat-menu-item (click)="setCurrentPartner(partner)">
        {{partner.name}}
      </button>
    }
  </mat-menu>

  @if (isAdmin) {
    <app-navbar-admin [partners]="partners"
    (partnerSelected)="setCurrentPartner($event)"></app-navbar-admin>
  }
</nav>